


























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<ElementPanel>({})
export default class ElementPanel extends Vue {
  @Prop()
  protected loading?: boolean;

  @Prop()
  protected compact?: boolean;
}
